import { apiRequest } from "./client";

export function listFowebPortalProducts(author) {
  const name = String(author || "").trim();
  const query = name ? `?author=${encodeURIComponent(name)}` : "";
  return apiRequest(`/fowebportalproducts${query}`);
}

export function createFowebPortalProduct(body) {
  return apiRequest("/fowebportalproducts", { method: "POST", body });
}

export function updateFowebPortalProduct(id, body) {
  return apiRequest(`/fowebportalproducts/${id}`, { method: "PUT", body });
}

export function deleteFowebPortalProduct(id) {
  return apiRequest(`/fowebportalproducts/${id}`, { method: "DELETE" });
}

export async function uploadFowebPortalProductMedia(id, files) {
  const list = Array.from(files || []);
  const added = [];
  let last;
  for (const file of list) {
    const body = new FormData();
    body.append("files", file);
    last = await apiRequest(`/fowebportalproducts/${id}/media`, { method: "POST", body });
    if (Array.isArray(last?.added)) added.push(...last.added);
  }
  return { ...(last || {}), added };
}

export function deleteFowebPortalProductMedia(id, index) {
  return apiRequest(`/fowebportalproducts/${id}/media/${index}`, { method: "DELETE" });
}
